import { ApplicationState } from '../../../state/ducks';
import { SubcontractorsBillingFilters } from './types';
import { SubcontractorBill } from '../../../state/models';

export const getSubcontractorsBillingFilters = (state: ApplicationState): SubcontractorsBillingFilters => state.customerService.reporting.subcontractorsBillingFilters;
export const getSubcontractorsBills = (state: ApplicationState): SubcontractorBill[] => state.customerService.reporting.subcontractorsBills;
export const areSubcontractorsBillsLoading = (state: ApplicationState): boolean => state.customerService.reporting.areSubcontractorsBillsLoading;